var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0764 12.5972C13.0764 11.0247 14.3512 9.75 15.9236 9.75C17.4961 9.75 18.7709 11.0247 18.7709 12.5972C18.7709 14.1697 17.4961 15.4444 15.9236 15.4444C14.3512 15.4444 13.0764 14.1697 13.0764 12.5972ZM15.9236 8.5C13.6608 8.5 11.8264 10.3344 11.8264 12.5972C11.8264 14.8601 13.6608 16.6944 15.9236 16.6944C18.1865 16.6944 20.0209 14.8601 20.0209 12.5972C20.0209 10.3344 18.1865 8.5 15.9236 8.5ZM15.9236 17.5278C12.4129 17.5278 9.33334 19.8673 9.33334 23.0139C9.33334 23.359 9.61317 23.6389 9.95834 23.6389C10.3035 23.6389 10.5833 23.359 10.5833 23.0139C10.5833 20.7854 12.851 18.7778 15.9236 18.7778C18.9962 18.7778 21.2639 20.7854 21.2639 23.0139C21.2639 23.359 21.5437 23.6389 21.8889 23.6389C22.2341 23.6389 22.5139 23.359 22.5139 23.0139C22.5139 19.8673 19.4343 17.5278 15.9236 17.5278Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/iconAvatar.284dc2fca353f955f4cfb674843fadf6.svg";
export { ForwardRef as ReactComponent };